export const filterTagsNews = [
    {
        id: "1",
        content: "пресс-релиз"
    },
    {
        id: "2",
        content: "мнение"
    },
    {
        id: "3",
        content: "интервью"
    },
    {
        id: "4",
        content: "презентация"
    },
    {
        id: "5",
        content: "категория"
    },
    {
        id: "6",
        content: "Мегамикс"
    },
    {
        id: "7",
        content: "Агрос"
    },
    {
        id: "8",
        content: "экспо"
    },
    {
        id: "9",
        content: "корма для рыб"
    },
    {
        id: "10",
        content: "Мегакорм"
    },
    {
        id: "11",
        content: "Мегамикс"
    },
    {
        id: "12",
        content: "экспо"
    },
    {
        id: "13",
        content: "корма для рыб"
    },
    {
        id: "14",
        content: "Мегакорм"
    },
    {
        id: "15",
        content: "Мегакорм"
    },
    {
        id: "16",
        content: "Мегакорм"
    },
    {
        id: "17",
        content: "корма для рыб"
    },
    {
        id: "18",
        content: "Мегакорм"
    },
    {
        id: "19",
        content: "корма для рыб"
    },
    {
        id: "20",
        content: "Мегакорм"
    },
    {
        id: "21",
        content: "Мегакорм"
    },
    {
        id: "22",
        content: "корма для рыб"
    },
    {
        id: "23",
        content: "Мегакорм"
    },
    {
        id: "24",
        content: "Агрос"
    }
]

export const selectList = [
    'Сначала популярные',
    'Сначала новые',
    'Сначала старые',
    'Сначала еще какие-то'
]